export const isRedirectedToSimplexUrl = (locationPath: string) => {
  // eslint-disable-next-line no-console
  console.debug(`URL external ${locationPath} arrived to utils/simplex`);
  return false;
};
